<div class="filters flex flex-wrap items-start gap-4" [formGroup]="form">
  <div class="w-full max-w-sm">
    <div class="mb-1 h-4"></div>
    <aux-input
      class="w-full"
      placeholder="Search"
      formControlName="search"
      icon="Search"
      iconPosition="left"
      hotKey="/"
    />
  </div>
  <div>
    <p class="mb-1 text-xs">Document Type:</p>
    <ng-select
      class="w-60 tabular-nums"
      placeholder="All"
      formControlName="documentTypes"
      bindValue="value"
      [multiple]="true"
      [searchable]="true"
      [items]="documentTypeOptions"
      (change)="onFilterChange()"
    >
      <ng-template let-items="items" let-clear="clear" ng-multi-label-tmp>
        @if (items.length === 1) {
          <div class="ng-value">
            @for (item of castItemsToOptions(items) | slice: 0 : 1; track item) {
              <div class="flex">
                <span class="ng-value-icon left" aria-hidden="true" (click)="clear(item)">×</span>
                <span class="ng-value-label overflow-hidden text-ellipsis">{{ item.label }}</span>
              </div>
            }
          </div>
        }
        @if (items.length > 1) {
          <div class="ng-value">
            <span class="ng-value-label">{{ items.length }} Selected</span>
          </div>
        }
      </ng-template>
    </ng-select>
  </div>
  <div>
    <p class="mb-1 text-xs">Vendor Contract:</p>
    <ng-select
      class="big-dropdown tabular-nums"
      style="width: 320px"
      placeholder="All"
      formControlName="vendors"
      bindValue="value"
      [multiple]="true"
      [searchable]="true"
      [items]="documentsPageService.vendors"
      (change)="onFilterChange()"
    >
      <ng-template let-item="item" ng-option-tmp>
        <div
          class="block truncate"
          #text
          [auxTooltip]="text.offsetWidth < text.scrollWidth ? item.label : ''"
          [auxTooltipPositions]="optionTooltipPositions"
        >
          {{ item.label }}
        </div>
      </ng-template>
      <ng-template let-items="items" let-clear="clear" ng-multi-label-tmp>
        @if (items.length === 1) {
          <div class="ng-value">
            @for (item of castItemsToOptions(items) | slice: 0 : 1; track item) {
              <div class="flex">
                <span class="ng-value-icon left" aria-hidden="true" (click)="clear(item)">×</span>
                <span
                  class="ng-value-label max-w-[200px] overflow-hidden text-ellipsis"
                  #text
                  [auxTooltip]="text.offsetWidth < text.scrollWidth ? item.label : ''"
                  [auxTooltipPositions]="optionTooltipPositions"
                >
                  {{ item.label }}
                </span>
              </div>
            }
          </div>
        }
        @if (items.length > 1) {
          <div class="ng-value">
            <span class="ng-value-label">{{ items.length }} Selected</span>
          </div>
        }
      </ng-template>
    </ng-select>
  </div>
  <div>
    <aux-site-select-dropdown
      formControlName="sites"
      class="block w-56"
      menuPosition="left"
      titleKey="name"
      menuPanelWidth="full"
    />
  </div>
  <div>
    <p class="mb-1 text-xs">From:</p>
    <aux-input
      placeholder="YYYY-MM-DD"
      formControlName="dateFrom"
      class="w-36"
      [type]="'date'"
      (change)="onFilterChange()"
    />
  </div>
  <div>
    <p class="mb-1 text-xs">To:</p>
    <aux-input
      placeholder="YYYY-MM-DD"
      formControlName="dateTo"
      class="w-36"
      [type]="'date'"
      (change)="onFilterChange()"
    />
  </div>
  <button
    class="btn--hyperlink whitespace-nowrap pt-8 focus:outline-none"
    (click)="resetAllFilters()"
  >
    Clear All
  </button>
</div>
